import { useState } from "react";
import { Link } from "react-router-dom";
import "../styles/forgotPassword.css";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    // API call will go here
    console.log("Reset link sent to:", email);

    setSubmitted(true);
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>Forgot Password</h2>
        <p className="text-muted">
          Enter your registered email and we’ll send you a reset link.
        </p>

        {submitted ? (
          <div className="success-message">
            ✅ Password reset link sent to <b>{email}</b>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="field-group">
              <label>Email</label>
              <input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <button type="submit" className="btn-primary mt-3 w-100">
              Send Reset Link
            </button>
          </form>
        )}

        <div className="auth-footer">
          <Link to="/login">← Back to Login</Link>
        </div>
      </div>
    </div>
  );
}
